export default "__VITE_ASSET__gvfbtZzW__"